export const SCREEN_DIMENSIONS = {
  SCREEN_MIN_WIDTH: 301,
  SCREEN_XS_WIDTH: 361,
  SCREEN_SM_WIDTH: 577,
  SCREEN_MD_WIDTH: 769,
  SCREEN_LG_WIDTH: 993,
  SCREEN_XL_WIDTH: 1201,
  SCREEN_XXL_WIDTH: 1401
};
